import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';

const SpinnerContext = createContext();

export const useSpinner = () => {
  const context = useContext(SpinnerContext);
  if (!context) {
    throw new Error('useSpinner must be used within a SpinnerProvider');
  }
  return context;
};

export const SpinnerProvider = ({ children }) => {
  const [isSpinnerVisible, setSpinnerVisible] = useState(false);
  const [spinnerText, setSpinnerText] = useState('Loading...');

  const toggleOn = useCallback((text = 'Loading...') => {
    setSpinnerText(text);
    setSpinnerVisible(true);
  }, []);

  const toggleOff = useCallback(() => {
    setSpinnerVisible(false);
  }, []);

  const toggle = useCallback(() => {
    setSpinnerVisible(prev => !prev);
  }, []);

  const value = useMemo(() => ({
    isSpinnerVisible,
    spinnerText,
    toggleOn,
    toggleOff,
    toggle,
  }), [isSpinnerVisible, spinnerText, toggleOn, toggleOff, toggle]);

  return (
    <SpinnerContext.Provider value={value}>
      {children}
    </SpinnerContext.Provider>
  );
};
